import React, { FC, ReactNode } from 'react';

import classNames from 'classnames';

import { Container } from '../UI';

import styles from './main-container.module.scss';

interface IMainContainerProps {
  children: ReactNode;
  fullBleed?: boolean;
  reserveHeaderSpace?: boolean;
}

const MainContainer: FC<IMainContainerProps> = ({
  children,
  fullBleed,
  reserveHeaderSpace = true,
}) => (
  <div
    className={classNames(styles['main-container'], {
      [styles['main-container_full-bleed']]: fullBleed,
      [styles['main-container_without-header-space']]: !reserveHeaderSpace,
    })}
  >
    <Container padding={fullBleed ? '0' : undefined}>{children}</Container>
  </div>
);

export { MainContainer };
